import { IAnalyticsConfig } from '@/core/modules/analytics/@types';

/**
 * Analytics config object
 */
const analyticsConfig: IAnalyticsConfig[] = [
	{
		analytics: 'adobe',
		version: ['galaxy'],
		params: [
			{
				environment: 'dev',
				domain: '*',
				script: 'https://assets.adobedtm.com/22baa8e94be8/2808c106b47e/launch-b24e2aa30503-development.min.js'
			},
			{
				environment: 'uat',
				domain: 'pfizermedical.pfizerpro.com',
				script: 'https://assets.adobedtm.com/22baa8e94be8/2808c106b47e/launch-EN1bd1f41357004950a414c9b380048fb9.min.js'
			}
		]
	},
	{
		analytics: 'm2m',
		version: ['fmd'],
	}
]

export default analyticsConfig;